import React, { useEffect, useState } from "react";
import { Select } from "antd";
import Loading from "components/shared-components/Loading";
import LanguagesApiService from "services/LanguagesApiService";

const TRANSLATIONS = {
  "en": "English",
  "es": "Español",
  "fr": "Français",
  "ca": "Català",
  "de": "Deutsch"
};

const LanguageSelector = ({
  placeholder = "",
  selectedValue,
  disabled = false,
  onChange = () => {},
  reducedVersion = false,
}) => {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(!reducedVersion);
  const [error, setError] = useState(false);

  const mapLanguagesWithTranslations = (languages) => {
    return languages.map((language) => {
      return {
        code: language,
        name: TRANSLATIONS[language]
      };
    })
  }

  const fetchLanguages = () => {
    setLoading(true);
    setError(false);

    LanguagesApiService.getLanguages('CENTRALIZED_APP')
      .then((response) => {
        const data = response.data.Languages;

        if (!Array.isArray(data)) {
          throw new Error("Invalid format");
        }

        const mappedLanguages = mapLanguagesWithTranslations(data);

        setLanguages(mappedLanguages);
      })
      .catch((err) => {
        console.error("LanguageSelect Error:", err);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
    }


  useEffect(() => {
    if (reducedVersion) {
      const reducedLanguages = ["es", "en"];
      const mappedReducesLanguages = mapLanguagesWithTranslations(reducedLanguages);
      setLanguages(mappedReducesLanguages);
      return;
    }

    fetchLanguages();
  }, [reducedVersion]);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "8px" }}>
        <Loading />
      </div>
    );
  }

  return (
    <Select
      placeholder={placeholder}
      disabled={disabled}
      onChange={onChange}
      value={selectedValue}
    >
      {languages.map((lang) => (
        <Select.Option key={lang.code} value={lang.code}>
          {lang.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default LanguageSelector;
